import { Typography } from '@prenuvo/halo';

import { PatientDocLink } from '../../patient-docs-side-panel.model';
import { usePatientDocs } from '../use-patient-docs.hook';
import { DocumentActions } from './document-actions.component';
import { DocumentRowContainer } from './document-row-container.component';

interface RadiologyReportRowProps {
  radiologyReportLink: PatientDocLink;
}

export function RadiologyReportRow({ radiologyReportLink }: RadiologyReportRowProps) {
  const { onUpdatePatientDocument } = usePatientDocs();

  const handleOpenDocument = () =>
    onUpdatePatientDocument({
      link: radiologyReportLink,
      name: 'RADIOLOGY_REPORT',
    });

  return (
    <DocumentRowContainer>
      <Typography
        translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.RADIOLOGY_REPORT"
        variant="paragraph-sm"
      />

      <DocumentActions link={radiologyReportLink} onOpenDocument={handleOpenDocument} />
    </DocumentRowContainer>
  );
}
